<template>
  <span :class="['copy-text', { 'copy-text--icon-only': iconOnly }]">
    <span v-if="!iconOnly" class="copy-text__value">{{ normalizedDisplay }}</span>
    <el-button
      v-if="copyValue"
      class="copy-text__button"
      type="text"
      size="mini"
      icon="el-icon-document-copy"
      title="复制"
      aria-label="复制"
      @click.stop.prevent="handleCopy"
    ></el-button>
  </span>
</template>

<script>
export default {
  name: 'CopyText',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    displayValue: {
      type: [String, Number],
      default: undefined
    },
    emptyText: {
      type: String,
      default: '-'
    },
    iconOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    copyValue() {
      if (this.value === undefined || this.value === null) return ''
      return String(this.value)
    },
    normalizedDisplay() {
      const raw = this.displayValue !== undefined && this.displayValue !== null
        ? this.displayValue
        : this.value

      if (raw === undefined || raw === null || raw === '') return this.emptyText
      return String(raw)
    }
  },
  methods: {
    copyWithTextarea(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      textarea.style.top = '0'
      document.body.appendChild(textarea)
      textarea.select()
      const copied = document.execCommand('copy')
      document.body.removeChild(textarea)
      return copied
    },
    notifyCopied() {
      this.$message.success('已复制')
    },
    notifyFailed() {
      this.$message.error('复制失败')
    },
    handleCopy() {
      if (!this.copyValue) return

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.copyValue)
          .then(this.notifyCopied)
          .catch(() => {
            this.copyWithTextarea(this.copyValue) ? this.notifyCopied() : this.notifyFailed()
          })
        return
      }

      this.copyWithTextarea(this.copyValue) ? this.notifyCopied() : this.notifyFailed()
    }
  }
}
</script>

<style scoped>
.copy-text {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  vertical-align: middle;
}

.copy-text--icon-only {
  justify-content: center;
  width: auto;
}

.copy-text__value {
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.5;
  word-break: break-all;
}

.copy-text__button {
  flex: 0 0 auto;
  padding: 0;
  font-size: 14px;
}
</style>
